import fixture from './AgentRegistrationProfileInfo.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    IAgentRegistrationProfileInfoClient,
} from 'interfaceAdapter/gatewaySchemas/IAgentRegistrationProfileInfoClient';
import { getCookie } from 'utils/cookie';

const csrfToken = getCookie('csrftoken');
const PATH = `${API_LOCATION_URL}/agent/registration_profile_info`;

export class AgentRegistrationProfileInfoClient implements IAgentRegistrationProfileInfoClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { token, mock = false } = input;
        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
            'X-HTTP-AUTH-TOKEN-A': token,
        };

        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });

            const { data, message } = await response.json();

            return {
                data,
                message,
            };
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
